var React = require('react');

function GuaranteedPickup (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.709 14.066V9.692c0-.69.56-1.25 1.25-1.25h12.083c.69 0 1.25.56 1.25 1.25M2.709 14.066v1.459a.625.625 0 101.25 0v-1.459h-1.25zm0 0h4.724m-.35-2.812h-1.25M2.293 7.192h2.01m11.398 0h2.009m-1.54 1.25L14.754 4.67a1.25 1.25 0 00-1.17-.812H6.417a1.25 1.25 0 00-1.17.812L3.832 8.442h12.335z","stroke":"#0B77D5","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.146 14.242l1.142 1.142 2.33-2.33m2.09.804a3.854 3.854 0 11-7.708 0 3.854 3.854 0 017.708 0z","stroke":"#0B77D5","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

GuaranteedPickup.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = GuaranteedPickup;

GuaranteedPickup.default = GuaranteedPickup;
